import styled from 'styled-components';
import { Pane, type PaneProps } from '@elfsight/widget-modal';
import * as RadixDialog from '@radix-ui/react-dialog';
import { useFiltersTheme } from '../../filters-theme-provider';
import { ModalContent } from './modal-content';
import type { FilterModalProps } from './types';

export type FiltersPaneProps = FilterModalProps &
  Omit<PaneProps, 'children' | 'position' | 'width' | 'onCloseRequest'> & {
    width?: number;
    position?: 'left' | 'right';
  };

export const FiltersPane = ({
  children,
  title,
  trigger,
  displayClearButton,
  clearButton,
  applyButton,
  withBackdrop = true,
  position = 'right',
  width = 420,
  show,
  onCloseRequest,
  onOpenRequest,
  onDiscardRequest,
  onApplyRequest,
  onResetRequest,
  onClearRequest,
  portalContainerElement,
  ...forwardingProps
}: FiltersPaneProps) => {
  const { modalBackground } = useFiltersTheme();

  return (
    <RadixDialog.Root open={show}>
      <RadixDialog.Trigger onClick={onOpenRequest} asChild>
        {trigger}
      </RadixDialog.Trigger>
      <Pane
        fixed={!portalContainerElement}
        show={show}
        onCloseRequest={() => {
          onCloseRequest();
          onDiscardRequest();
        }}
        closeOnEscape
        closeOnOutsideClick
        disableScroll
        withBackdrop={withBackdrop}
        backdropColor="rgba(17,17,17,0.7)"
        width={width}
        position={position}
        ariaLabel={title}
        style={{ backgroundColor: modalBackground }}
        portalContainerElement={portalContainerElement}
        {...forwardingProps}
      >
        <Content
          title={title}
          onCloseRequest={onCloseRequest}
          onApplyRequest={onApplyRequest}
          onResetRequest={onResetRequest}
          onDiscardRequest={onDiscardRequest}
          onClearRequest={onClearRequest}
          displayClearButton={displayClearButton}
          clearButton={clearButton}
          applyButton={applyButton}
        >
          {children}
        </Content>
      </Pane>
    </RadixDialog.Root>
  );
};

const Content = styled(ModalContent)`
  height: 100%;
`;
